import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'mtn-user-not-registered',
  templateUrl: './user-not-registered.component.html',
  styleUrls: ['./user-not-registered.component.scss']
})
export class UserNotRegisteredComponent  {

  constructor() {
  }


}
